module.exports = __webpack_public_path__ + "img/img-1.c15e3c07.jpg";